import { useEffect } from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { trackPageView } from "./lib/analytics";
import { captureUtms } from "./lib/attribution";

function RouteTracker() {
  const location = useLocation();
  useEffect(() => {
    captureUtms();
    trackPageView(location.pathname, document.title);
  }, [location.pathname]);
  return null;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <RouteTracker />
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
